import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getAriaAttributes } from '../../../../../util/getAriaAttributes/getAriaAttributes.js';
import { getDataAttributes } from '../../../../../util/getDataAttributes/getDataAttributes.js';
import '../../../../../util/styles/index.js';
import { VALIDATION_STATE_ICON_MAP } from '../constants.js';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["id", "state", "controlContainerRef", "lineClamp", "message"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useValidationMessage = function useValidationMessage(_ref) {
  var id = _ref.id,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'default' : _ref$state,
    controlContainerRef = _ref.controlContainerRef,
    lineClamp = _ref.lineClamp,
    message = _ref.message,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes,
    restProps = _getDataAttributes.rest;
  var _getAriaAttributes = getAriaAttributes(restProps),
    ariaAttributes = _getAriaAttributes.ariaAttributes,
    rest = _getAriaAttributes.rest;
  var isInputActive = React.useMemo(function () {
    var _controlContainerRef$;
    var inputElement = controlContainerRef === null || controlContainerRef === void 0 || (_controlContainerRef$ = controlContainerRef.current) === null || _controlContainerRef$ === void 0 ? void 0 : _controlContainerRef$.querySelector('input, textarea');
    return inputElement && document.activeElement === inputElement;
  }, [controlContainerRef]);
  return {
    containerProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      id: id,
      'aria-live': state === 'error' ? 'assertive' : 'polite'
    }, isInputActive && {
      'aria-relevant': 'all',
      'aria-atomic': false
    }), mapAdsStyles({
      display: 'flex',
      gap: '4',
      alignItems: 'flex-start'
    })), dataAttributes), ariaAttributes), rest),
    iconProps: {
      iconId: VALIDATION_STATE_ICON_MAP.get(state),
      color: 'base.intent',
      typographySize: 'caption-default'
    },
    textProps: _objectSpread({
      textColor: 'base.intent',
      tag: 'span',
      variant: 'caption-default',
      lineClamp: lineClamp
    }, lineClamp && {
      title: message
    })
  };
};

export { useValidationMessage };
//# sourceMappingURL=useValidationMessage.js.map
